import { render, staticRenderFns } from "./SectionLoStudioLegale.vue?vue&type=template&id=2f4f2e08&"
import script from "./SectionLoStudioLegale.vue?vue&type=script&lang=js&"
export * from "./SectionLoStudioLegale.vue?vue&type=script&lang=js&"
import style0 from "./SectionLoStudioLegale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports